import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-forget-password',
  templateUrl: './success-forget-password.component.html',
  styleUrls: ['./success-forget-password.component.scss']
})
export class SuccessForgetPasswordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector('body').setAttribute('themebg-pattern', 'theme1');
  }

}
